import * as types from './conclusions.types';

export const conclusionsPageSelectors: types.IConclusionsPageSelectors = {
  selectConclusions: (state) => state.page.conclusions.conclusions,
  selectShowRecapValidationErrors: (state) => state.page.conclusions.showRecapValidationErrors,
};
